import type { KeyboardEvent } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, CircularProgress, Input, InputAdornment } from '@mui/material';

interface AutosuggestionInputProps {
  label: string;
  value: string;
  resolvingLabel: boolean;
  expanded: boolean;
  listboxId: string;
  activeDescendant?: string;
  onChange: (value: string) => void;
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const AutosuggestionInput = ({
  label,
  value,
  resolvingLabel,
  expanded,
  listboxId,
  activeDescendant,
  onChange,
  onKeyDown,
}: AutosuggestionInputProps) => (
  <Box sx={{ minWidth: 400 }}>
    <Input
      autoFocus
      fullWidth
      disableUnderline
      value={value}
      placeholder={`Search ${label.toLocaleLowerCase()}`}
      inputProps={{
        role: 'combobox',
        'aria-label': `Search ${label.toLocaleLowerCase()}`,
        'aria-autocomplete': 'list',
        'aria-expanded': expanded,
        'aria-controls': listboxId,
        'aria-activedescendant': activeDescendant,
      }}
      onChange={event => onChange(event.target.value)}
      onKeyDown={onKeyDown}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
      endAdornment={
        resolvingLabel ? <CircularProgress color="primary" size={20} aria-label="Loading suggestions" /> : undefined
      }
      sx={{
        px: 1,
        py: 1,
        '&:before, &:after, &:hover:not(.Mui-disabled):before': {
          borderBottom: 0,
        },
      }}
    />
  </Box>
);

export default AutosuggestionInput;
